const getBreadcrumb = (navi) => {
    const breadcrumb = [
        {
            text: 'backoffice.nav.DeveloperTool',
        },
        {
            text: 'backoffice.nav.Product',
        }
    ];
    breadcrumb.push(navi);
    return breadcrumb;
};
export const productsClients = [
    {
        name: 'productsClients',
        path: '/productsClients',
        redirect: {
            name: 'productsManagement',
        },
        component: () => import(/* webpackChunkName: "productsClients" */ '../../views/products-clients/ProductsClients/ProductsClients.vue'),
        children: [
            {
                name: 'productsManagement',
                path: '/productsManagement',
                component: () => import(/* webpackChunkName: "productsClients" */ '../../views/products-clients/Products/Products.vue'),
                props: true,
                meta: {
                    breadcrumb: getBreadcrumb({
                        text: 'backoffice.productsClients.tabs.product',
                        active: true,
                    }),
                    permission: 'ProductGet',
                },
            },
            {
                name: 'clientsManagement',
                path: '/clientsManagement',
                component: () => import(/* webpackChunkName: "productsClients" */ '../../views/products-clients/Clients/Clients.vue'),
                props: true,
                meta: {
                    breadcrumb: getBreadcrumb({
                        text: 'backoffice.productsClients.tabs.client',
                        active: true,
                    }),
                    permission: 'ProductClientsGetList',
                },
            }
        ],
    }
];
